import React from 'react'
import history from '../../utils/appHistory'
import { t } from 'translation'

const RequestAccessStepTwo = () => {
  return (
    <div className="tab_content_wrap auth_block">
      <h1 className="section_title v4_mod color_mod offset_v4_mod decor_mod center_mod">
        {t('requestAccess.HEADER')}
      </h1>
      <div className="auth_block_descr decor_mod offset_mod center_lvl_mod">
        <p>{t('requestAccess.DESCRIPTION_2')}</p>
        <p>{t('requestAccess.DESCRIPTION_3')}</p>
      </div>
      <div className="phone_system_buttons offset_mod">
        <button
          className="phone_system_buttons_item btn_download"
          onClick={() => history.replace('/auth')}
        >
          {t('requestAccess.GO_BACK')}
        </button>
      </div>
    </div>
  )
}

export default RequestAccessStepTwo
